import {DesktopTopLevelItem, DesktopTopLevelItemFTNAV_2029, Flyout, FlyoutContent} from "./desktopElements";
import {TopBrands} from "./topBrands";
import {ShortcutCategories} from "./shortcutCategories";
import {observeMousemove} from "./mouseSpeedTracker";
import {isTouchDevice, initializeElement} from "./utils";

initializeElement(DesktopTopLevelItem);
initializeElement(DesktopTopLevelItemFTNAV_2029);
initializeElement(Flyout);
initializeElement(FlyoutContent);
initializeElement(TopBrands);
initializeElement(ShortcutCategories);

/*                                                                                 */
/*                   */
document.addEventListener("click", event => {
    const selectors = [DesktopTopLevelItem.customElement, DesktopTopLevelItemFTNAV_2029.customElement].join(",");
    if (!event.target.closest(".nav_desktop-global-navigation")) {
        event.target.querySelectorAll(selectors).forEach(
            (topLevelItem) => {
                if (topLevelItem.isActive()) topLevelItem.exitFlyoutWithTracking();
            }
        );
    }
});

if (!isTouchDevice()) observeMousemove();
